import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useRouter } from 'next/router'
import { App } from '@capacitor/app'
import { Browser } from '@capacitor/browser'

import { setAccessToken } from 'redux-web/utils/session/actions'
import { fetchMe } from 'redux-web/utils/user/actions'

const AppUrlListener = () => {
  const dispatch = useDispatch()
  const router = useRouter()

  useEffect(() => {
    App.addListener('appUrlOpen', event => {
      if (event.url.startsWith('citifyd://')) {
        const url = new URL(event.url)
        const path = event.url.replace('citifyd://', '/')

        const tokenFromCapacitorBrowser = url.searchParams.get(
          'tokenFromCapacitorBrowser'
        )

        if (tokenFromCapacitorBrowser) {
          dispatch(
            setAccessToken({
              accessToken: tokenFromCapacitorBrowser,
              isGuest: false,
            })
          )

          dispatch(fetchMe())
        }

        setTimeout(() => {
          Browser.close()
          router.push(path)
        }, 1000)

        return
      }

      const slug = event.url.split('.com').pop()

      if (slug) {
        Browser.close()

        router.push(slug)
      }
    })
  }, [router])

  return null
}

export default AppUrlListener
